<template>
  <router-view />
  <div id="dialog"></div>
</template>
<script>
import { watch, getCurrentInstance } from 'vue';
import { useGetters, useMutations, useActions } from '@/utils/mapStore';
import { useRoute, useRouter } from 'vue-router';
import { watchSoftwareStatus } from '@/utils/upgrade';
export default {
  name: 'app',
  setup() {
    const { proxy } = getCurrentInstance();
    const route = useRoute();
    const { getSystemInfo, doGetDutySection, getEcho, getPosWebConfig } = useActions('system', [
      'getSystemInfo',
      'doGetDutySection',
      'getEcho',
      'getPosWebConfig',
    ]);
    const checkSoftwareStatus = useActions('upgrade', ['checkSoftwareStatus']);
    //取得頁面初始化所需要的資訊
    const init = (async function () {
      //每一分鐘打一次echo
      const setGetEcho = () => {
        getEcho();
        return setGetEcho;
      };
      let echoTimer;
      echoTimer && clearInterval(echoTimer);
      echoTimer = setInterval(setGetEcho(), 60000);

      watch(
        () => route.path,
        () => {
          //取得系統版號和權限
          getSystemInfo();
          getPosWebConfig();
          getEcho();
          //每一小時打一次getDutySection & checkStatus
          const setGetSystem = () => {
            if (route.path === '/guest') return;
            doGetDutySection();
            checkSoftwareStatus();
            return setGetSystem;
          };
          let systemTimer;
          systemTimer && clearInterval(systemTimer);
          systemTimer = setInterval(setGetSystem(), 60000 * 60);
        }
      );
      //監聽軟體更新狀態
      if (route.path !== '/guest') watchSoftwareStatus();
    })();
    //偵測如果show_alert_type出現2，就要強制交班清帳
    const getSystem = useGetters('system', ['getSystem']);
    const getOrderId = useGetters('order', ['getOrderId']);
    const SET_SHOW_SHIFT = useMutations('accounting', ['SET_SHOW_SHIFT']);
    const SET_ORDER_ID = useMutations('order', ['SET_ORDER_ID']);
    const doAbrogateOrder = useActions('order', ['doAbrogateOrder']);
    const dorRestoreOrder = useActions('handleOrder', ['dorRestoreOrder']);
    const doLogout = useActions('system', ['doLogout']);
    const router = useRouter();

    watch(
      () => getSystem.value?.show_alert_type,
      () => {
        if (getSystem.value.show_alert_type === 2) {
          proxy
            .$message('提醒', '前一天未清帳，請先進行交班清帳', {
              hideClose: true,
              confirmText: '交班清帳',
            })
            .then(() => {
              SET_SHOW_SHIFT(true);
            });
        } else if (getSystem.value.show_alert_type === 3) {
          if (getOrderId.value) doAbrogateOrder();
          proxy
            .$message('提醒', '尚有未結帳/未沖銷訂單<br/>請至掛單及訂單管理未沖銷頁面結清後，並進行清帳作業')
            .catch((e) => e);
        }
        // 存在隔夜的未完成訂單
        else if (getSystem.value.show_alert_type === 4) {
          SET_ORDER_ID(getSystem.value.pending_order_id);
          proxy
            .$confirm({
              hideClose: true,
              content: '前一天尚有未完成訂單，是否要回復訂單？',
              confirmText: '回復訂單',
              cancelText: '取消訂單',
            })
            .then(async () => {
              // 回復訂單
              await dorRestoreOrder(getSystem.value.pending_order_id);
              router.push('/order');
            })
            .catch(async () => {
              // 取消訂單
              await doAbrogateOrder();
              doLogout();
            });
          return;
        }
      }
    );
    return { init };
  },
};
</script>
